function Footer() {
  return (
    <footer className="footer">
      <span>owenlytle@protonmail.com</span>
      <span className="footer-separator">;</span>
      <a href="https://instagram.com/ooowen.ceramics" target="_blank" rel="noopener noreferrer">instagram</a>
    </footer>
  );
}

export default Footer;